<div class="header-container">
  <!-- Only show tab navigation if there are multiple tabs -->
  <div class="nav-tabs" *ngIf="showTabs">
    <button 
      *ngFor="let tab of tabs"
      class="nav-tab"
      [class.active]="activeTab === tab"
      (click)="selectTab(tab)">
      {{ tab }}
    </button>
  </div>

  <!-- Show single tab header without navigation if only one tab -->
  <div class="single-tab-header" *ngIf="!showTabs && tabs.length === 1">
    <h2 class="single-tab-title">{{ tabs[0] }}</h2>
  </div>
</div>